;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');
	var checkboxFieldTemplate = JST.Checkbox;
	Model.Registration = Model.Registration.extend({
		defaults: {
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			team_name: '',
			team_supported: 0,
			avatar: '',
			terms: 0,
			news: 1,
			birthday:  '',
			mobile: '',
			games_attend: 'none',
			watch_tv: 'regularly',
			country: '',
			postcode: '',
			gender: 'male',
			jmc_hear_about: '',
			disable_notifications: 0
		},
		schema: {
			first_name:{
				title: 'First name*',
				editorClass: 'first_name',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Enter First Name'
				},
				validators: ['first_name_required', 'first_name_regexp']
			},
			last_name:{
				title: 'Last name*',
				editorClass: 'last_name',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Enter Last Name'
				},
				validators: [ 'last_name_required', 'last_name_regexp']
			},
			email:{
				title: 'Email Address*',
				editorClass: 'email',
				editorAttrs: {
					placeholder: 'name@email.com',
					title: 'Your email will be used as your username when you log in'
				},
				validators: ['email_validation', 'email_required']
			},
			confirm_email:{
				title: 'Confirm Email Address*',
				editorClass: 'confirm_email',
				editorAttrs: {
					placeholder: 'name@email.com'
				},
				validators: ['email_validation', 'email_required','email_match']
			},
			password:{
				title: 'Password*',
				type: 'Password',
				editorClass: 'password',
				editorAttrs: {
					minlength: 8,
					placeholder: 'Enter Password'
				},
				validators: ['password_required','password_regexp']
			},
			passwordConfirm:{
				title: 'Confirm Password*',
				type: 'Password',
				editorClass: 'passwordConfirm',
				editorAttrs: {
					placeholder: 'Enter Password'
				},
				validators: ['passwordConfirm_required','passwordConfirm_regexp', 'password_match']
			},
			birthday: {
				title: 'Date of Birth*',
				editorClass: 'birthday',
				type: 'Date',
				yearStart: 2013,
				yearEnd: 1916,
				validators: ['birthday_required']
			},
			team_name:{
				title: 'Username*',
				editorAttrs: {
					maxlength: 40,
					placeholder: 'Enter Username'
				},
				validators:  ['team_name_required', 'team_name_regexp']
			},
			team_supported: {
				title: 'Team Supported*',
				editorClass: 'team_supported',
				type: 'Select',
				options: function(callback, editor) {
					if(editor.form.data){

						editor.setValue(0);

						if(editor.form.data.squads[0].id !== 0){

							editor.form.data.squads.unshift({
								id: 0,
								name: 'Pick your team'
							});

						}

						callback(_.map(editor.form.data.squads , function(value){
							return {
								val: value.id,
								label: value.name
							}
						}));
					}
				},
				validators: ['team_supported_required']
			},
			terms: {
				type: 'CheckboxCustom',
				title: "I have read and accepted JMC's  <a href='http://www.jmc.com.au/privacy' target='_blank'>Privacy Policy</a> and the <a href='#/help/terms'>Terms and Conditions</a>",
				options:{},
				template: checkboxFieldTemplate,
				validators: ['terms_required']
			},
			news: {
				type: 'CheckboxCustom',
				title: 'I agree to receive communication from Chemist Warehouse about special offers',
				options:{},
				template: checkboxFieldTemplate
			},
			avatar: {
				type: "ImagePicker",
				button_text: 'Add Picture',
				user_img_url: CONFIG.IMAGES_URL+'nouserpic.png',
				template: JST.ImageUploader
			},
			mobile: {
				title: 'Mobile Number*',
				editorClass: 'mobile',
				editorAttrs: {
					maxlength: 15,
					minlength: 9,
					placeholder: 'Enter Mobile Number'
				},
				validators: ['mobile_required', 'mobile_is_number', 'mobile_length']
			},
			gender: {
				type: 'Radio',
				editorClass: 'gender',
				title: 'Gender',
				options:[
					{labelHTML: 'Male <i class="fa fa-mars"></i>', val: 'male'},
					{labelHTML: 'Female <i class="fa fa-venus"></i>', val: 'female'}
				],
				validators: []
			},
			country: {
				type: 'Select',
				editorClass: 'country',
				title: 'Country:*',
				options: function(callback, editor) {
					if(editor.form.data){

						editor.setValue(0);

						if(editor.form.data.countryList[0].code !== 0){

							editor.form.data.countryList.unshift({
								code: 0,
								name: 'Please enter your Country of Residence'
							});

						}

						callback( _.map(editor.form.data.countryList , function(value){
							return {
								val: value.code,
								label: value.name
							}
						}));

					}
				},
				validators: ['country_required']
			},
			games_attend: {
				type: 'Select',
				editorClass: 'games_attend',
				title: 'How many games do you attend per season?',
				options: ['1-2', '3-6', '7+', 'none']
			},
			watch_tv: {
				type: 'Select',
				editorClass: 'games_attend',
				title: 'How often do you watch AFL on TV?',
				options: [
					{val: 'regularly', label: 'Regularly (at least once per week)'},
					{val: 'often', label: 'Often (every 2-3 weeks)'},
					{val: 'rarely', label: 'Rarely or never'}
				]
			},
			postcode: {
				title: 'Postcode:*',
				editorClass: 'postcode',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Postcode:*'
				},
				help: '<p class="postcode-help">Only Tasmanian residents are eligible to win the prizes. Please refer to the  <a href="#/help/terms">terms and conditions</a> for full details</p>',
				validators: ['postcode_check_country', 'postcode_length', 'postcode_is_number']
			},
			address: {
				title: 'Residential Address:*',
				editorClass: 'address',
				editorAttrs: {
					minlength: 2,
					maxlength: 100,
					placeholder: 'Start typing your Residential Address:*'
				},
				validators: []
			},
			jmc_hear_about:{
				type: 'Select',
				editorClass: 'jmc_hear_about',
				title: 'How did you find out about the JMC Footy Tipping competition?*',
				options: [
					{val: '', label: 'Please Select one'},
					{ val: 'youtube', label:'YouTube'},
					{ val: 'facebook', label: 'Facebook' },
					{ val: 'online', label: 'Online' },
					{ val: 'radio', label: 'Radio' },
					{ val: 'tv', label: 'TV' },
					{ val: 'word_of_mouth', label: 'Word of mouth' },
					{ val: 'other', label: 'Other' },
				],
				validators: ['required']
			},
			state: {
				type: 'Select',
				editorClass: 'state',
				title: 'State:*',
				options: function(callback, editor) {
					if(editor.form.data) {

						if(!editor.model.changed.state){
							editor.setValue('WA');
						}
						var states = _.map(editor.form.data.statesList, function (value) {
							return {
								val:   value.id,
								label: value.state
							}
						});

						callback(states);
					}
				},
				validators: [
					function checkCountry(value, formValues) {
						var err = {
							type: 'required',
							message: 'State is required for Australia'
						};
						if (formValues.country == 'AU' && formValues.state == '' ) return err;
					}
				]
			},
		}

	});
}(window, APP, Backbone, Marionette, $, _));


